import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TriggerGroupEntity } from './trigger-group.entity';

@Entity('_titan_api_query')
export class TitanApiQueryEntity extends BaseEntity {
	@Column('int', { name: '_fk__object__id', unsigned: true })
	public fkObjectId!: number;

	@Column('text', { name: '_query' })
	public query!: string;

	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('text', { name: '_fieldMapping' })
	public fieldMapping!: string;

	@Column('int', { name: '_version', default: () => "'0'" })
	public version!: number;

	@Column('text', { name: '_displayFields' })
	public displayFields!: string;

	@OneToMany(
		() => TriggerGroupEntity,
		(triggerGroup) => triggerGroup.fkTitanApiQuery,
		{},
	)
	public triggerGroups!: Array<TriggerGroupEntity>;
}
